import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import { nextBrandsPageAction, prevBrandsPageAction, setBrandsPageSizeAction } from '../../redux/actions/brandsActions';

const BrandsPagination = () => {
  const pageable = useSelector((state) => state.brands?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextBrandsPageAction}
      onPrevPageClickAction={prevBrandsPageAction}
      onPageSizeChangeAction={setBrandsPageSizeAction}
    />
  );
};

export default BrandsPagination;
